import React from "react";
import { Card, Badge, ProgressBar, Nav, Spinner } from "react-bootstrap";

const IspettorePercorsoView = ({ percorso, nome, cognome, loading }) => {
  const [tab, setTab] = React.useState("contenuti");

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p className="text-muted mt-2">Caricamento percorso formativo…</p>
      </div>
    );
  }

  if (!percorso) return null;

  const contenuti = percorso.contenuti || [];
  const oreSeguite = percorso.ore_seguite_corso ?? 0;
  const oreTotali = percorso.ore_totali_corso ?? 0;
  const pct = oreTotali > 0 ? Math.min(100, Math.round((oreSeguite / oreTotali) * 100)) : 0;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">
          Percorso formativo — {nome} {cognome}
        </h5>
        <Badge bg="secondary">Sola lettura</Badge>
      </div>

      <Card className="mb-3 border-0 shadow-sm">
        <Card.Body>
          <div className="d-flex justify-content-between small text-muted mb-1">
            <span>Ore seguite: {oreSeguite} / {oreTotali}</span>
            <span>{pct}%</span>
          </div>
          <ProgressBar now={pct} label={`${pct}%`} />
        </Card.Body>
      </Card>

      <Nav variant="tabs" className="mb-3">
        <Nav.Item>
          <Nav.Link active={tab === "contenuti"} onClick={() => setTab("contenuti")}>Contenuti</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link active={tab === "calendario"} onClick={() => setTab("calendario")}>Calendario</Nav.Link>
        </Nav.Item>
      </Nav>

      {tab === "contenuti" && (
        <Card className="border-0 shadow-sm">
          <Card.Body>
            {contenuti.length > 0 ? (
              contenuti.map((c) => (
                <div key={c.id_contenuto} className="d-flex justify-content-between align-items-start border-bottom py-2">
                  <div>
                    <strong>{c.titolo}</strong>
                    <div className="small text-muted">{c.tipo_contenuto}</div>
                    {c.data_inizio && (
                      <small className="text-muted d-block">
                        Inizio: {new Date(c.data_inizio).toLocaleString("it-IT")}
                      </small>
                    )}
                    {c.completato && c.data_fine_prevista && (
                      <small className="text-success d-block">
                        Completato il {new Date(c.data_fine_prevista).toLocaleDateString("it-IT")}
                      </small>
                    )}
                    {!c.completato && c.data_inizio && (
                      <small className="text-warning d-block">In corso</small>
                    )}
                  </div>
                  <Badge bg={c.completato ? "success" : c.data_inizio ? "warning" : "secondary"}>
                    {c.completato ? "Completato" : c.data_inizio ? "Iniziato" : "Non iniziato"}
                  </Badge>
                </div>
              ))
            ) : (
              <p className="text-muted mb-0 text-center py-3">Nessun contenuto registrato</p>
            )}
          </Card.Body>
        </Card>
      )}

      {tab === "calendario" && (
        <Card className="border-0 shadow-sm">
          <Card.Body>
            {(percorso.lezioni?.length || percorso.esami?.length) ? (
              <>
                {percorso.lezioni?.map((l) => (
                  <div key={l.id_lezione} className="mb-2 small">
                    <i className="bi bi-calendar-event me-1 text-primary" />
                    Lezione: {l.titolo || l.data_lezione}
                  </div>
                ))}
                {percorso.esami?.map((e) => (
                  <div key={e.id_calendario_esame} className="mb-2 small">
                    <i className="bi bi-mortarboard me-1 text-success" />
                    Esame: {e.data_esame}
                  </div>
                ))}
              </>
            ) : (
              <p className="text-muted mb-0 text-center py-3">Nessuna attività programmata</p>
            )}
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default IspettorePercorsoView;
